import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    branchesList: [],
    branchArr: [],
    branchArray: [],
    branchID: '',
    branchName: '',
    selectedBranch: null,
    isEditing: false
  };
  
  const mutations = {
    initializeStore(state){
      state.branchesList = [];
      state.branchArr = [];
      state.branchArray = [];
      state.branchID = '';
      state.branchName = '';
      state.selectedBranch = null;
      state.isEditing = false;
    },
    LIST_BRANCHES(state, branches) {
      state.branchesList = branches;
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
      }
    },
    SET_SELECTED_BRANCH(state, branch) {
      state.selectedBranch = branch;
      state.isEditing = true;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    RESET_SEARCH_FILTERS(state){

    }
  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },

    async createBranch({ commit,state }, formData) {
      return axios.post('api/v1/create-branch/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },

    fetchBranches({ commit,state }, formData) {
      state.branchArr = [];
      axios.post(`api/v1/get-branches/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.branchArr.push((response.data[i].name));
        }
        commit('LIST_BRANCHES', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchBranch({ commit,state }, formData) {
      axios.post(`api/v1/get-branches/`,formData)
      .then((response)=>{
        state.selectedBranch = response.data;
        commit('SET_SELECTED_BRANCH',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },

    async updateBranch({ commit,state }, formData) {
      return axios.put(`api/v1/update-branch/`,formData)
      .then((response)=>{
        return response;  
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
      
    },

    deleteBranch({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Branch?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Branch!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-branch/`,formData)
          .then((response)=>{
            if(response.status == 200){
              Swal.fire("Poof! Branch removed succesfully!", {
                  icon: "success",
              }); 
            }else{
              Swal.fire({
                title: "Error Deleting Branch",
                icon: "warning",
              });
            }       
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Branch has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  